// src/components/Footer.js
import React from 'react';
import './Footer.css'; // Import the CSS for the footer

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-columns">
          {/* Column 1: Smt. Lilatai Deshmukh School Info */}
          <div className="footer-column">
            <h3 className="footer-title">Smt. Lilatai Deshmukh Residential Special School for Education, Training & Rehabilitation For Mentally Retarded Girls</h3>
            <p><strong>Address:</strong> Madanwada Itwari in Front Of Datta Mandir, Nagpur</p>
            <p><strong>Call:</strong> <a href="tel:+918888851101">8888851101</a>, <a href="tel:+917020992018">7020992018</a></p>
            <p><strong>Whatsapp:</strong> <a href="https://wa.me/918888851101" target="_blank" rel="noopener noreferrer">8888851101</a></p>
          </div>

          {/* Column 2: Indutai Dhoble Workshop Info */}
          <div className="footer-column">
            <h3 className="footer-title">Indutai Dhoble Workshop and Rehabilitation Centre For Mentally Challenged Girl</h3>
            <p><strong>Address:</strong> 292, Jawahar Nagar, Near Jawahar Sabhagruh, Nagpur. 440024</p>
            <p><strong>Call:</strong> <a href="tel:+918793909183">8793909183</a>, <a href="tel:+919404537177">9404537177</a></p>
            <p><strong>Whatsapp:</strong> <a href="https://wa.me/918793909183" target="_blank" rel="noopener noreferrer">8793909183</a></p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Vishwambhar Shikshan Sanstha. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;